/**
 * The parameters Auth0 returns in the address when a sign-in comes back. Both
 * have to be present for the address to be one, and the exchange spends them,
 * so leaving them behind means a reload replays a sign-in that can no longer
 * complete.
 */
export const REDIRECT_CALLBACK_PARAMS = ["code", "state"];

/** Where auth0-spa-js records a sign-in it has started. Tracks the library. */
const TRANSACTION_STORAGE_KEY_PREFIX = "a0.spajs.txs.";

// Whole parameters, not substrings of the address: `code=` also occurs inside
// ordinary query names (`promo_code=`).
export function hasRedirectCallbackParams(search: string): boolean {
  const params = new URLSearchParams(search);

  return params.has("code") && params.has("state");
}

/**
 * Whether this tab holds the sign-in a returning callback belongs to. The
 * record lives in session storage, so it belongs to the one tab the sign-in
 * began in, and it has to be read before the exchange, which spends it either
 * way.
 *
 * The library reports both "no record here" and "the record does not match" as
 * the same `Invalid state`, and they are different faults — the first is a
 * sign-in coming back somewhere other than where it started. Which one happened
 * is only answerable from here.
 */
export function hasPendingTransaction(clientId: string): boolean {
  try {
    return (
      sessionStorage.getItem(`${TRANSACTION_STORAGE_KEY_PREFIX}${clientId}`) !==
      null
    );
  } catch {
    // A browser refusing storage outright can be holding no sign-in.
    return false;
  }
}
